export const frequentQuestions = {
    '19': [
        {
            question: '¿Qué cubre mi seguro?',
            body: 'Robo de cartera, mochila, llaves, documentos, tarjetas de crédito - débito que estén dentro del bolso(agenda, anteojos, celular, etc)',
        },
        {
            question: '¿Qué plazo tengo para realizar la denuncia del siniestro ?',
            body: 'El asegurado deberá comunicarse con Cardif dentro de los 3 primeros días de ocurrido el hecho.',
        },
        {
            question: '¿Cómo puedo obtener mi póliza ?',
            body: 'Podrás descargarla en la página https://bnpparibascardif.com.ar en la opción Clientes; ingresando su DNI y fecha de nacimiento.',
        },
        {
            question: '¿Qué documentación necesito presentar ante un siniestro ?',
            body: 'Debes completar el formulario otorgado por la Compañía, acercarte a realizar la denuncia Policial.',
        },
        {
            question: '¿Cuál es la diferencia entre robo y hurto?',
            body: 'Robo se refiere cuando una persona se apodera de un bien ajeno utilizando fuerza en las cosas o intimidación o violencia en las personas.',
        },
        {
            question: '¿Cómo puedo dar de baja mi cobertura ?',
            body: 'Podrás comunicarte con la Compañía al 0800 - 122 - 7343',
        },
        {
            question: '¿Cuáles son los medios de pago disponibles ?',
            body: 'Visa, Argencard, Mastecard, Cabal y Naranja',
        },
        {
            question: '¿A partir de cuándo me cubre el seguro ?',
            body: 'Desde las cero(0) horas del día siguiente a la fecha de solicitarlo',
        }
    ],
    '8': [
        {
            question: '¿Qué cubre mi seguro?',
            body: ' Incendio edificio, remoción de escombros, daños estéticos por incendio robo, alimentos en frezzer, responsabilidad civil, huracán- vendaval- tornado, granizo, cristales, todo riesgo electrodomésticos.',
        },
        {
            question: '¿Cómo puedo gestionar el servicio de asistencia?',
            body: 'El asegurado deberá comunicarse al centro de atención telefónica mediante la línea gratuita 0-800-333-0957 de la compañía las 24 hs, los 365 días del año.'
        },
        {
            question: '¿Qué plazo tengo para realizar la denuncia del siniestro?',
            body: 'El asegurado deberá comunicarse con Cardif dentro de los 3 primeros días de ocurrido el hecho.'
        },
        {
            question: '¿Tengo que hacer un listado de las cosas que tengo en mi casa? ¿Me cubre electrodomésticos por alta o baja tensión?',
            body: 'Si se amplía la cobertura a los daños sufridos por los aparatos y/o equipos electrónicos de uso doméstico producidos ante este inconveniente.'
        },
        {
            question: '¿Qué pasa con mi cobertura si tengo que mudarme?',
            body: 'Deberás informar el nuevo domicilio.'
        },
        {
            question: '¿Cómo puedo dar de baja mi cobertura?',
            body: 'Deberás contactarte con la Compañía al 0800-122-7343'
        },
        {
            question: '¿Cuáles son los medios de pago disponibles?',
            body: ' Visa, Argencard, Mastercard, Cabal y Naranja'
        },
        {
            question: '¿Cuál es la diferencia entre robo y hurto?',
            body: 'Robo se refiere cuando una persona se apodera de un bien ajeno utilizando fuerza en las cosas o intimidación o violencia en las personas.'
        },
        {
            question: '¿Recibo una indemnización en caso de sufrir un siniestro dentro de mi domicilio?',
            body: 'Se indemnizará al asegurado la pérdida por Robo y Hurto del contenido que se halle en la vivienda asegurada.'
        },
        {
            question: '¿A partir de cuándo me cubre el seguro ?',
            body: 'Desde las cero(0) horas del día siguiente a la fecha de solicitarlo',
        },
    ],
    '12': [
        {
            question: '¿Cómo puedo obtener las asistencias que ofrece la cobertura?',
            body: ' Podrás solicitarlas a la Compañía de IBERO al 0800-444-0619 las 24 hs 365 días del año.',
        },
        {
            question: '¿Cuáles son los medios de pago disponibles?',
            body: 'Podes efectuar el pago con Tarjeta de crédito Visa, Argencard, Mastecard, Cabal y Naranja',
        },
        {
            question: ' ¿Cómo denuncio un siniestro?',
            body: 'Deberás contactarte con la Compañía al 0800-666-8400',
        },
        {
            question: ' ¿Cómo puedo dar de baja mi cobertura?',
            body: 'Podrás comunicarte con la aseguradora al 0800-888-5080 de lunes a viernes de 09 hs a 18 hs o al correo atencionvidagrupo@prudential.com',
        },
        {
            question: '¿Qué cubre mi seguro?',
            body: 'Muerte accidental, invalidez total y permanente por accidente, renta diaria por internación, discapacidad temporal en el hogar por accidente.',
        },
        {
            question: '¿Cuáles son las asistencias que incluyen?',
            body: 'Médico online, kinesiología a domicilio, 50% descuento en farmacias, 40 % ortopedias y ópticas, médico a domicilio, odontologia de urgencia.',
        },
    ],
    '62': [
        {
            question: ' ¿Qué cubre mi seguro?',
            body: ' Al contratar esta cobertura podrás mejorar tu CV a través de una academia on-line que brinda la Compañía por una plataforma que podrás ingresar las veces que desees, además podrás realizar la búsqueda de nuevos empleos y comparar los sueldos, te ayudamos a diseñar tu nuevo CV y podrás ir más tranquilo a la entrevista ya que entrenaremos tus habilidades para que puedas destacarte del resto. Y lo mejor de todo que con esta cobertura podrás tener una protección en caso de estar desempleado.',
        },
        {
            question: '¿Cómo funciona?',
            body: 'Una vez contratado la cobertura recibirás un email con todos los servicios que ofrece y podrás registrarte para ingresar a esta plataforma.',
        },
        {
            question: '¿Quién dicta los cursos?',
            body: 'Cada curso es gestionado por profesores de las mejores universidades e instituciones educativas.',
        },
        {
            question: '¿Cómo funcionan los cursos?',
            body: 'Los cursos se dictan a través de videoconferencias grabadas para que los clientes puedan ingresar en sus horarios disponibles. Cada curso incluye evaluaciones',
        },
        {
            question: '¿Cuáles son los cursos que voy a encontrar en la academia online?',
            body: 'Éxito profesional, (36 cursos), Gestión y liderazgo (64 cursos), Marketing y negocios (53 cursos), Datos (33 cursos), Tecnología (64 cursos)',
        },
        {
            question: '¿Cuántos cursos voy a encontrar en plataforma?',
            body: 'Son 250 cursos activos en plataforma.',
        },
        {
            question: '¿Cuáles son los medios de pago disponibles?',
            body: 'Visa, Argencard, Mastercard, Cabal y Naranja.',
        },
        {
            question: '¿Cómo denuncio el siniestro en caso de quedar desempleado?',
            body: 'Deberás contactarte con la Compañía Cardif al 0800-122-7343 de 09 hs a 21 hs o a través de la página www.bnpparibascardif.com.ar',
        },
    ],
    '159': [
        {
            question: ' ¿Qué cubre mi seguro?',
            body: 'Notebook, Tablet.'
        },
        {
            question: '¿Cuáles son los riesgos cubiertos?',
            body: ' Robo total (no hurto), daño Accidental parcial, daño Accidental total.'
        },
        {
            question: '¿Qué ventajas tiene esta cobertura?',
            body: 'La cobertura es en la vía pública y se extiende a los equipos ubicados en el interior del automóvil del asegurado, además cuenta con un servicio de asistencia de Help Desk disponible las 24 hs los 365 días del año, para que puedas comunicarte telefónicamente y también por problemas informáticos como instalación, configuración. etc. La cobertura es extendida para el titular, cónyuge, hijos y padres.',
        },
        {
            question: '¿Cuáles son los medios de pago?',
            body: 'Tarjeta de crédito'
        },
        {
            question: '¿Cuáles son los canales de contacto?',
            body: 'Atención al cliente 0800-999-4100 de lunes a viernes de 08 a 20 hs.',
        },
        {
            question: '¿Cómo realizar la denuncia?',
            body: ' El cliente puede hacer la denuncia online ingresando http://www.bbvaseguros.com.ar/. Para ello deberá registrarse y también podrá descargar su póliza o podrá comunicarse al 0800- 999-4100 de lunes a viernes de 8 hs a 20 hs.',
        },
    ],
    '161': [
        {
            question: '¿Qué cubre este seguro?',
            body: 'Esta cobertura protege los equipos electrónicos portátiles de uso diario ante su robo en la vía pública, incluyendo telefonos celulares, reproductores de audio multimedia, auriculares, parlantes, inalámbricos, e- books, cámaras fotográficas y filmadoras. No incluye: Notebook y Tablets'
        },
        {
            question: '¿Cuáles son los medios de pago disponibles?',
            body: 'Tarjeta de crédito'
        },
        {
            question: '¿Cuántos siniestros cubre por año?',
            body: 'Cubre 2 indemnizaciones por año'
        },
        {
            question: 'Mi hijo es menor de edad. ¿Puedo contratar la cobertura para él?',
            body: 'Si, se puede adquirir la cobertura para los menores de edad'
        },
        {
            question: '¿Debo informar cuántos dispositivos tengo?',
            body: ' No hace falta, ya que sólo se solicitará un comprobante de compra al momento del siniestro.'
        },
        {
            question: '¿Cómo realizo la denuncia?',
            body: ' El cliente puede realizar la denuncia online ingresando a la web: www.bbvaseguros.com.ar . Para ello deberá registrarse y podrá descargar su póliza. O también podrás contactarte al 0800-999-4100 de lunes a viernes de 8 hs a 20 hs'
        },
    ],
    generalQuestions: [
        {
            question: '¿Qué es un seguro?',
            body: 'Un seguro es un instrumento financiero que ayuda a reducir la incertidumbre económica sobre el futuro.'
        },
        {
            question: '¿Cuál es el beneficio de contratar un seguro?',
            body: 'Produce paz mental al reducir el riesgo de sufrir una gran pérdida económica y/o genera estabilidad económica al grupo familiar.'
        },
        {
            question: ' ¿Cuáles son los medios de pago?',
            body: 'La cobertura se debitará mensualmente a través de tarjeta de crédito.'
        },
        {
            question: 'En caso de que cuente con 2 seguros similares con otra aseguradora, cuando sufra un siniestro, ¿Puedo cobrar los dos?',
            body: 'Si, pagan las dos compañías en forma proporcional a las sumas aseguradas del siniestro ocurrido.'
        },
        {
            question: '¿Qué información brinda el certificado de mi cobertura?',
            body: ' La información que obtendrás será los beneficios del seguro que adquiriste, sus exclusiones, detalle del plan solicitado.'
        },
        {
            question: '¿Para qué me sirve el Certificado?',
            body: ' Es una constancia de que contás con el seguro contratado y tiene validez hasta que recibas la póliza'
        },
        {
            question: '¿Es posible actualizar o modificar mi seguro una vez contratado?',
            body: 'Si se puede modificar y para realizarlo debes comunicarte a la Compañía que está relacionada a tu seguro.'
        },
    ]
};

